import { VEHICLE_MODULE_PREFIX } from '../constants';
export const VEHICLE_GET_VEHICLE_META_DATA_REQUEST = `${VEHICLE_MODULE_PREFIX}_GET_VEHICLE_META_DATA_REQUEST`;
export const VEHICLE_GET_VEHICLE_META_DATA_SUCCESS = `${VEHICLE_MODULE_PREFIX}_GET_VEHICLE_META_DATA_SUCCESS`;
export const VEHICLE_GET_VEHICLE_META_DATA_FAILURE = `${VEHICLE_MODULE_PREFIX}_GET_VEHICLE_META_DATA_FAILURE`;
/**
 * Action creator to retrieve vehicle meta data
 * @param vehicle IVehicle
 * @param language string
 * @returns
 */
export const onGetVehicleMetaDataRequest = (vehicle, language) => ({
    type: VEHICLE_GET_VEHICLE_META_DATA_REQUEST,
    payload: { vehicle, language }
});
/**
 * Action creator to fill vehicle state with vehicle meta data passed in payload.
 * @param payload IVehicleMetaData
 * @returns
 */
export const onGetVehicleMetaDataSuccess = (payload) => ({
    type: VEHICLE_GET_VEHICLE_META_DATA_SUCCESS,
    payload
});
/**
 * Action creator to dispatch failure action
 * @param failureMessage string
 * @returns
 */
export const onGetVehicleMetaDataFailure = (failureMessage) => ({
    type: VEHICLE_GET_VEHICLE_META_DATA_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=getVehicleMetaDataActions.js.map